import React from "react";
import AppointmentsMyPage from "./AppointmentsMyPage.jsx";

export default function AppointmentsAllPage() {
  return (
    <AppointmentsMyPage
      listId="all-appointments"
      showAllAppointments
      pageTitle="All Appointments"
      pageSubtitle="Admin/Manager overview of all appointments across counsellors."
    />
  );
}
